import React, { Fragment, memo, useMemo } from 'react'

import { useUnit } from 'effector-react'

import { Typo } from 'components/_old/Typo/Typo'

import { Paper } from 'components/atoms/Paper'
import { Skeleton } from 'components/atoms/Skeleton'
import { Typography } from 'components/atoms/Typography'

import { $shouldShowProvidersBlock, $providersString, $shouldShowSkeletonProviders } from '../index'

const TransferConditions = memo((): React.ReactElement => {
  const [shouldShowSkeletonProviders, shouldShowProvidersBlock, providersString] = useUnit([
    $shouldShowSkeletonProviders,
    $shouldShowProvidersBlock,
    $providersString,
  ])

  const firstLine = useMemo(() => {
    const line = shouldShowProvidersBlock && providersString && `${providersString} your current pension provider`

    if (shouldShowSkeletonProviders && line) {
      return (
        <Skeleton shown inline>
          {line}
        </Skeleton>
      )
    }

    return line
  }, [shouldShowSkeletonProviders, shouldShowProvidersBlock, providersString])

  return (
    <Fragment>
      <Typography size={24} weight="semibold" lineHeight="small">
        <Typo>We can only proceed with this transfer if</Typo>
      </Typography>
      <Paper top={32}>
        <Typography size={14}>
          <Typo>
            <ul>
              {firstLine && <li>{firstLine}</li>}
              <li>Your pension is not in drawdown; and</li>
              <li>
                Your pension is not subject to any existing or proposed divorce, earmarking or pension sharing order,
                trustee in bankruptcy order or any other type of court order.
              </li>
            </ul>
          </Typo>
        </Typography>
      </Paper>
    </Fragment>
  )
})
TransferConditions.displayName = 'TransferConditions'

export { TransferConditions }
